/**
 * The icon catalog offered in the editor's nav-item / tab icon picker. Each `name` maps to a
 * crisp Material icon in the generated app (see navIcon() in app-template AppRoot.kt — KEEP IN
 * SYNC). The emoji is only a visual proxy shown in the dashboard picker.
 */
export interface NavIconOption {
  name: string;
  label: string;
  emoji: string;
}

export const NAV_ICONS: NavIconOption[] = [
  { name: 'home', label: 'Home', emoji: '🏠' },
  { name: 'store', label: 'Store', emoji: '🛍️' },
  { name: 'cart', label: 'Cart', emoji: '🛒' },
  { name: 'search', label: 'Search', emoji: '🔍' },
  { name: 'settings', label: 'Settings', emoji: '⚙️' },
  { name: 'account', label: 'Account', emoji: '👤' },
  { name: 'info', label: 'About', emoji: 'ℹ️' },
  { name: 'favorite', label: 'Favorites', emoji: '❤️' },
  { name: 'notifications', label: 'Alerts', emoji: '🔔' },
  { name: 'location', label: 'Location', emoji: '📍' },
  { name: 'calendar', label: 'Calendar', emoji: '📅' },
  { name: 'star', label: 'Featured', emoji: '⭐' },
  { name: 'mail', label: 'Contact', emoji: '✉️' },
  { name: 'phone', label: 'Call', emoji: '📞' },
  { name: 'web', label: 'Website', emoji: '🌐' },
  { name: 'list', label: 'List', emoji: '📋' },
];

export const NAV_ICON_NAMES = NAV_ICONS.map((i) => i.name);

/** The emoji proxy for an icon name (for previews); falls back to a dot. */
export function iconEmoji(name: string | undefined): string {
  return NAV_ICONS.find((i) => i.name === name)?.emoji ?? '•';
}
